import React from "react";

function PopupColor({ children, show }) {
  const preventClose = (event) => {
    event.stopPropagation();
  };

  return (
    <div className={`popups ${show ? "show" : ""}`}>
      <div className="popupcolor" onClick={preventClose}>
        {children}
      </div>
    </div>
  );
}

export default PopupColor;
